<template>
    <div>
        <apexchart height="550" type="bar" :options="chartOptions" :series="chartSeries" />
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
    components: {
        apexchart
    },
    computed: {
        chartOptions() {
            return {
                yaxis: {
                    title: {
                        text: 'Percentual'
                    },
                    labels: {
                        formatter: function (val) {
                            return val + '%'
                        }
                    }
                },
                xaxis: {
                    type: 'categories',
                    categories: this.chartLabels,
                    title: {
                        text: 'Semana de alojamento'
                    },
                    labels: {
                        style: {
                            colors: '#000000de'
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                responsive: [{
                    options: {
                        legend: {
                            position: 'right'
                        }
                    }
                }],
                markers: {
                  size: 4
                },
                stroke: {
                    width: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + '%'
                        }
                    }
                },
                legend: {
                    position: 'top',
                },
                fill: {
                    opacity: 1
                },
            };
        },
        chartSeries() {
            let semanas = this.values[0].data.length;
            let columns = this.values.map(v => ({
                name: v.name,
                data: v.data,
                type: 'bar'
            }));
            let lines = [];
            
            for (const key in this.limitData) {
                
                let tamanhoArray = parseInt(semanas) - this.limitData[parseInt(key)].pontos.length

                const filler = Array(tamanhoArray < 0 ? tamanhoArray * -1 : tamanhoArray).fill(0)

                lines.push({
                    type: 'line',
                    name: 'Limite Mortalidade: ' + this.limitData[key].nmTabela,
                    data: [...this.limitData[key].pontos.sort((a, b) => {
                        return (
                            a.nrDia - b.nrDia
                        )
                    }).map(v => v.mortalidade), ...filler]
                });
            }

            return [...columns, ...lines];
        },
        chartLabels() {
            return this.categories
        },
        chartMax() {
            return Math.max(...this.values.map(v => v.max))
        },
    },
    props: {
        values: Array,
        categories: Array,
        limitData: Array
    }
}
</script>


